<template>

	<div id="wp" class="wp">
		<div class="black"></div>

		<div class="nexabtbd">
			<div :class="{'nex_cd_top':active}" class="nex_ab_top">
				<ul>
					<li @click="muenList(index)" v-for="(item,index) in listLeft" :class="{'cur':curyes==index}" >{{item}}</li>
					<div class="clear"></div>
				</ul>
			</div>



			<div class="nex_ab_main">
				<div class="nex_ab_bottom">
					<ul>
						<!-- <v-companyProfile></v-companyProfile> -->
                    <router-view ></router-view>


						<div class="clear"></div>
					</ul>
				</div>
			</div>

			<div class="clear"></div>
		</div>
		<!-- <v-cebianlan> </v-cebianlan> -->

	</div>
</template>

<script>
	import Cebianlan from '../../views/cebianlan/cebianlan.vue'
		// import companyProfile from './companyProfile.vue'

	export default {
		name: 'index',
		data() {
			return {
				curyes:0,
				active: false,
				listLeft: [
					"公司介绍",
          	"企业资质",
					"大事记",
					"公司招聘",

					"联系我们"
				],

			}
		},
		components: {
			'v-cebianlan': Cebianlan,
			// 'v-companyProfile':companyProfile
		},
		methods: {
			muenList(index){
				this.curyes=index;
        window.sessionStorage.setItem("curyes", index);
				switch (index){
					case 0:
					this.$router.push('/home/about/companyProfile')
					break;
					case 1:
					this.$router.push('/home/about/MediaReport')
					break;
					case 2:
					this.$router.push('/home/about/Memorabilia')

					break;
					case 3:
					this.$router.push('/home/about/Recruitment')

					break;
					case 4:
					this.$router.push('/home/about/ContactUs')
					break;

				}

			},
			handleScroll() { //改变元素#searchBar的top值
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

				if (scrollTop > 100) {
					this.active = true;

				} else {
					this.active = false;
				}
			}
		},
		mounted() { //给window添加一个滚动滚动监听事件
    var that = this;
    setInterval(function(){
      that.curyes =  window.sessionStorage.getItem("curyes");
      // console.log(1)

    },100)

			window.addEventListener('scroll', this.handleScroll)
			this.$router.push('/home/about/companyProfile')
		},
		destroyed() { //离开该页面需要移除这个监听的事件
			window.removeEventListener('scroll', this.handleScroll)
		},
	}
</script>

<style scoped="scoped">

	.nex_cd_top {
		width: 206px;
		float: left;
		padiving: 15px;
		background: #fff;
		position: fixed;
		top: 50px;
		z-index: 2;

	}

	.black {

		width: 100%;
		height: 107px;
		opacity: 0.7;
		background: rgba(0, 0, 0);
		/* margin-left: -500px; */
	}

	/* 	.header_top{
    position: fixed;
	top: 0;
    z-index: 999;
    width: 100%;
} */
	/* .nexheader {
    border-bottom: 0 !important;
    padding: 3px 0 !important;
    position: fixed;
    top: 0px;
    width: 100%;
    z-index: 150;
    left: 0px;
    margin-top: 0px;
    padding: 0px;
    background: rgba(0, 0, 0, 0.7);
    min-width: 1180px;
    height: 60px;
    -webkit-transition: all 0.3s linear;
    transition: all 0.3s linear;
} */
	/* 	.nex_topgt{
		display: none!important;
	} */
	.clear {
		clear: both;
	}

	.nex_ab_top {
		width: 206px;
		float: left;
		padiving: 15px;
		background: #fff;
	}

	.nex_ab_top ul li {
		display: block;
		font-size: 16px;
		color: #555;
		line-height: 50px;
		width: 206px;
		height: 50px;
		text-align: center;
		cursor: pointer;
	}

	ul li {
		list-style: none;
	}

	.nex_ab_top ul li.cur {
		color: #fff;
		background: #0095FF;
	}

	.nex_topbards {
		height: 200px;
		width: 924px;
		background: url(http://www.mools.net/lims/web/OfficialWebsite/about/bg1.jpg) center no-repeat;
		position: relative;
	}

	.nex_aboutusbx {
		border-radius: 4px;
		width: 864px;
		background: #fff;
		overflow: hidden;
		position: relative;
		z-index: 3;
		padding: 30px;
	}

	.nex_about_title h1 {
		border-left: 6px solid #0095FF;
		padding-left: 15px;
		font-size: 18px;
		color: #333;
		font-weight: 500;
		height: 20px;
		line-height: 20px;
		margin-bottom: 20px;
	}

	.nex_ab_line_txt {
		line-height: 30px;
		font-size: 16px;
		color: #666;
		margin-bottom: 25px;
	}

	.move-span {
		background: none;
	}

	.move-span {
		background-image: none !important;
		border: 0 none !important;
		margin: 0 !important;
		padding: 0 !important;
		border-width: 0px;
		height: auto;
	}

	.frame-1 {
		background-color: transparent !important;
		background-image: none !important;
		border: 0 none !important;
		margin: 0 !important;
		padding: 0 !important;
		border-width: 0px;
		height: auto;
	}

	.frame,
	.frame-tab {
		margin-bottom: 10px;
		border: 1px solid #ededed;
		background: #FFF;
	}

	.frame-1-c {
		background-color: transparent !important;
		background-image: none !important;
		border: 0 none !important;
		margin: 0 !important;
		padding: 0 !important;
		border-width: 0px;
		height: auto;
	}

	.cl:after {
		content: ".";
		display: block;
		height: 0;
		clear: both;
		visibility: hidden;
	}

	.nex_ab_main {
		position: relative;
		float: right;
		width: 924px;
	}

	.wp,
	#wp {
		width: 100%!important;

		margin: 0 auto;
	}

	.nexabtbd {
		margin: 20px auto;
		width: 1180px !important;
	}

	.nex_ab_top {
		/* position: static; */
		width: 206px;
		float: left;
		padding: 15px;
		background: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/components/about/about.vue